import React from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros';
import PropTypes from 'prop-types';

const TopTipoPublicaciones = ({ tipos, tablaEstilo }) => {
  const tipoArray = tipos?.topTipoPublicacion || tipos;
  const parseArray = tipoArray?.map(t => {
    return { ...t, montoVentas: t.montoVentas || t.ventas }
  })
  return (
    <div className="table-responsive mb-3">
      <table
        className="table table-sm table-hover mb-0"
        style={{ background: tablaEstilo?.fondo, borderRadius: 6, overflow: 'hidden' }}
      >
        <thead className="thead-light">
          <tr style={{ background: tablaEstilo?.header }}>
            <th>Id</th>
            <th>Descripcion</th>
            <th className="text-right">Unidades</th>
            <th className="text-right">Monto Ventas</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(parseArray) && parseArray.length > 0 ? (
            parseArray.map((t, idx) => (
              <tr key={`tipo-row-${idx}`}>
                <td>{Number.isFinite(t?.idTipoPublicacion) ? t.idTipoPublicacion : '-'}</td>
                <td>{t?.descripcion || t?.tipo || '-'}</td>
                <td className="text-right">{t?.unidadesVendidas || '-'}</td>
                <td className="text-right">${formatoDecimal(t?.montoVentas) || '-'}</td>
              </tr>
            ))
          ) : (
            <tr key="tipo-empty">
              <td colSpan={4} className="text-center text-muted py-3">Sin datos</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
TopTipoPublicaciones.propTypes = {
  // Redux props
  tipos: PropTypes.oneOfType([PropTypes.shape({
    topTiposPublicacion: PropTypes.array
  }), PropTypes.array]),
  tablaEstilo: PropTypes.shape({
    fondo: PropTypes.string,
    header: PropTypes.string,
  })
}

export default TopTipoPublicaciones;
